var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 108,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.251 0h530v108h-530z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.211.32h30.785v17.81H.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.388.32h30.784v17.81H.388z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.72.32h30.784v17.81H.719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.89.32h30.784v17.81H.889z"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.1%",
    y: "-8.2%",
    width: "112.4%",
    height: "117.5%",
    filterUnits: "objectBoundingBox",
    id: "k"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.209680944 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.882 79.068l22.84-19.698C64.84 41.427 40.642 28.45 34.13 20.438 33.677 17.435 22.743-1.616 17.08 2.213 13.989-1.032 6.925-1.492 6.925 6.264-.481 4.662-1.577 14.35 1.887 16.843c-4.862 2.505.791 15.95 15.192 17.771 6.28 2.874 28.547 17.691 66.803 44.454z",
    id: "l"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.1%",
    y: "-8.2%",
    width: "112.4%",
    height: "117.5%",
    filterUnits: "objectBoundingBox",
    id: "n"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.209680944 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.882 79.068l22.84-19.698C64.84 41.427 40.642 28.45 34.13 20.438 33.677 17.435 22.743-1.616 17.08 2.213 13.989-1.032 6.925-1.492 6.925 6.264-.481 4.662-1.577 14.35 1.887 16.843c-4.862 2.505.791 15.95 15.192 17.771 6.28 2.874 28.547 17.691 66.803 44.454z",
    id: "o"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F7F0FA",
    transform: "rotate(-180 265.25 54)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EDDBF4",
    mask: "url(#b)",
    cx: 265.701,
    cy: 143.034,
    rx: 138.701,
    ry: 126
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.602 171.96s-4.064-4.689-8.521-5.053c-4.457-.365-9.68 3.027-13.622-1.686-3.942-4.715-1.195-8.368 1.367-8.382 2.56-.015 4.92 1.426 5.509 4.261 0 0 3.395-6.616-2.375-10.823-5.77-4.208-17.009-4.971-21.806 6.69-4.795 11.662-4.457 17.635-4.457 17.635s.635 2.44 2.249-.336c1.615-2.777 3.093-3.725 3.093-3.725s.027 11.308 5.729 20.158c1.074 1.45 2.062 1.246 1.994-1.568-.069-2.815 1.124-5.761 1.124-5.761s2.299 14.182 22.052 18.715l7.664-30.125z",
    fill: "#405660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.86 168.88c-1.871-15.423-5.004-25.555-8.66-31.783-4.88-8.313-9.421-8.137-9.421-8.137l-26.55 1.11-26.551-1.11s-4.542-.176-9.421 8.137c-3.655 6.228-6.788 16.36-8.659 31.782-8.334 2.134-14.502 9.657-14.502 18.638 0 9.25 6.537 16.97 15.25 18.83h87.765c8.715-1.86 15.252-9.58 15.252-18.83 0-8.98-6.17-16.504-14.504-18.638",
    fill: "#516772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.25 187.517c0-8.98-6.17-16.504-14.504-18.637-1.87-15.423-5.004-25.555-8.659-31.782-4.878-8.314-9.42-8.138-9.42-8.138l-26.551 1.11-.033-.001-.604 7.526V159s-4.127 3.022-6.65 5.288c-.631.63 1.729-.126 3.325-.755 0 0-.802 1.659-.99 2.246-.19.586.172.797.937 0 .765-.799 3.82-1.303 3.82-1.303v41.872h44.077c8.714-1.86 15.251-9.58 15.251-18.83",
    fill: "#627885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.75 193.804c-11.029 0-20.052-9.002-20.052-20.006v-8.387c0-11.003 9.023-20.006 20.051-20.006 11.028 0 20.051 9.003 20.051 20.006v8.387c0 11.004-9.023 20.006-20.05 20.006",
    fill: "#E4E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.862 164.299c-.794 1.48 2.026.303 3.622-.326 0 0-1.098 1.23-1.287 1.817-.19.587.306.8 1.318.355 1.769-.778 3.44 1.509 3.44 1.509v26.139c10.824-.24 19.609-9.129 19.609-19.983v-8.387c0-11.004-9.024-20.006-20.052-20.006v11.317s-3.627 3.116-6.65 7.565",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.643 189.23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.248 10.372c.188-2.79 2.492-5.004 5.338-5.004l.03.003C5.783 2.558 8.1.32 10.96.32c2.452 0 4.497 1.649 5.143 3.887a5.33 5.33 0 0 1 2.68-.74c2.362 0 4.345 1.53 5.066 3.641a5.343 5.343 0 0 1 1.774-.322 5.368 5.368 0 0 1 5.373 5.362c0 .174-.035.337-.05.508l.05.003v1.19c0 2.363-1.969 4.28-4.398 4.28H4.606c-2.426 0-4.395-1.916-4.395-4.277V10.37l.037.002z",
    fill: "#7B8C95",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.917 189.23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.136 10.372c-.188-2.79-2.493-5.004-5.338-5.004-.011 0-.021.003-.031.003C25.6 2.558 23.284.32 20.424.32c-2.452 0-4.497 1.649-5.143 3.887a5.327 5.327 0 0 0-2.681-.74c-2.361 0-4.345 1.53-5.066 3.641a5.343 5.343 0 0 0-1.773-.322 5.368 5.368 0 0 0-5.373 5.362c0 .174.034.337.05.508l-.05.003v1.19c0 2.363 1.97 4.28 4.398 4.28h21.991c2.427 0 4.395-1.916 4.395-4.277V10.37l-.036.002z",
    fill: "#7B8C95",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.55 150.446c-2.356-12.925-8.202-18.855-8.202-18.855l-55.887-2.631s-6.586 8.561-8.942 21.486c-2.355 12.925-1.177 49.52-1.177 49.52h19.515s.352-36.827.352-37.35c0-7.88 7.98-14.267 17.825-14.267 9.845 0 17.826 6.387 17.826 14.267 0 .548.351 37.35.351 37.35h19.516s1.177-36.595-1.178-49.52",
    fill: "#809298"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.002 189.23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.467 10.372c-.187-2.79-2.492-5.004-5.337-5.004-.012 0-.022.003-.032.003-.165-2.813-2.482-5.05-5.343-5.05-2.451 0-4.497 1.649-5.143 3.887a5.327 5.327 0 0 0-2.68-.74c-2.362 0-4.345 1.53-5.066 3.641a5.343 5.343 0 0 0-1.773-.322 5.368 5.368 0 0 0-5.374 5.362c0 .174.035.337.05.508l-.05.003v1.19c0 2.363 1.97 4.28 4.398 4.28H27.11c2.427 0 4.395-1.916 4.395-4.277V10.37l-.037.002z",
    fill: "#FEFEFE",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.699 148.348c9.844 0 17.825 6.389 17.825 14.269 0 .548.352 37.349.352 37.349h19.516s1.177-36.594-1.178-49.52c-2.355-12.925-8.103-21.19-8.103-21.19l-28.373 2.335-.482 6.004v10.771c.148-.003.294-.018.443-.018M309.935 74.865s5.77-20.868-5.603-47.902c-4.85-10.512-6.69-11.18-9.533-8.677-2.843 2.504-17.56 16.855-21.575 30.37h-15.01c-4.013-13.515-18.732-27.866-21.574-30.37-2.844-2.503-4.683-1.835-9.534 8.677-11.373 27.034-5.603 47.902-5.603 47.902-7.024 12.606-9.281 42.21-9.281 42.21s6.271-9.637 24.082-5.632c4.856 1.092 9.247 2.914 13.071 4.984 3.28 8.683 7.979 11.671 11.5 12.617 2.757.17 4.612.208 4.823.212h.021a120.199 120.199 0 0 0 4.844-.212c3.521-.946 8.22-3.934 11.5-12.617 3.825-2.07 8.215-3.892 13.07-4.984 17.812-4.005 24.084 5.632 24.084 5.632s-2.258-29.604-9.282-42.21",
    fill: "#8C9DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.73 129.256V74.71c-3.889-5.017-3.262-9.627-4.922-12.13-1.66-2.503-7.873-2.754-7.873-2.754.627-.75 7.025-3.88 7.025-3.88-2.635-.375-7.025 0-7.025 0 6.272-4.756 12.795-7.289 12.795-7.289h-7.505c-4.015-13.517-18.732-27.868-21.576-30.371-2.842-2.504-4.683-1.835-9.532 8.678-11.374 27.032-5.603 47.9-5.603 47.9-7.025 12.608-9.283 42.211-9.283 42.211s6.272-9.637 24.084-5.632c4.854 1.091 9.246 2.914 13.071 4.984 3.28 8.682 7.979 11.672 11.5 12.618 2.756.169 4.611.207 4.822.211h.022",
    fill: "#627885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.609 95.298c1.963-5.882 4.685-20.025-9.865-27.534-14.24-7.348-24.588 6.867-25.025 7.48-.437-.613-10.785-14.828-25.024-7.48-14.551 7.51-11.829 21.652-9.865 27.534 0 0-13.968-2.754-18.61 21.777l5.52-.333v4.171c3.847-1.836 9.868-1.669 18.565 3.17 8.506 4.734 28.52 5.157 29.393 5.173h.042c.874-.016 20.887-.44 29.394-5.172 8.696-4.84 14.717-5.007 18.564-3.17l.041-4.172 5.479.333c-4.642-24.53-18.61-21.777-18.61-21.777",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.305 111.443c-17.813-4.005-24.083 5.632-24.083 5.632l5.518-.334v4.172c3.847-1.835 9.867-1.668 18.565 3.17 8.697 4.84 29.435 5.174 29.435 5.174s-11.623-13.81-29.435-17.814M295.175 111.443c17.813-4.005 24.084 5.632 24.084 5.632l-5.52-.334v4.172c-3.845-1.835-9.866-1.668-18.564 3.17-8.697 4.84-29.435 5.174-29.435 5.174s11.623-13.81 29.435-17.814",
    fill: "#E4E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.761 71.769s3.135-13.392 14.426-18.523c6.02-2.503 7.651-.75 8.78-5.757 1.128-5.007-5.87-20.906-10.411-25.031-2.384-2.253-4.265-.877-5.52 1.627-1.254 2.503-11.414 23.279-7.275 47.684",
    fill: "#DADFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.977 28.882s4.766 6.341 6.188 13.517c1.422 7.176-2.676 5.924-5.185 7.26-2.508 1.335-5.184 2.502-5.937 3.003-.752.5-2.09-.834 0-2.252 2.091-1.42 4.934-3.839 2.76-5.007-2.175-1.168-3.93-1.835-4.683-2.754-.753-.917 0-1 1.756-.917 1.757.083 3.61.083 2.055-2.17-1.553-2.253-1.888-3.67-1.888-5.006 0-1.335.837-.834 2.342.917 1.505 1.753 2.006 2.588 1.839.167-.167-2.419-.515-8.637.753-6.758",
    fill: "#F3F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.782 84.117c0 3.18-2.583 5.757-5.77 5.757-3.187 0-5.77-2.577-5.77-5.757 0-3.18 2.583-8.03 5.77-8.03 3.187 0 5.77 4.85 5.77 8.03",
    fill: "#1786C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.346 83.47a3.33 3.33 0 0 1-3.334 3.328 3.33 3.33 0 0 1-3.334-3.327 3.33 3.33 0 0 1 3.334-3.327 3.33 3.33 0 0 1 3.334 3.327",
    fill: "#050706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.106 80.967a2.016 2.016 0 0 1-2.018 2.014 2.016 2.016 0 0 1-2.018-2.014c0-1.111.903-2.013 2.018-2.013 1.114 0 2.018.902 2.018 2.013",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.064 107.313c0 2.972-4.174 6.195-9.324 6.195-5.15 0-9.324-3.223-9.324-6.195 0-2.972 4.175-4.569 9.324-4.569 5.15 0 9.324 1.597 9.324 4.569",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.677 71.769s-3.136-13.392-14.425-18.523c-6.02-2.503-7.652-.75-8.78-5.757-1.129-5.007 5.87-20.906 10.41-25.031 2.384-2.253 4.266-.877 5.52 1.627 1.254 2.503 11.415 23.279 7.275 47.684",
    fill: "#DADFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.461 28.882s-4.766 6.341-6.188 13.517c-1.422 7.176 2.676 5.924 5.185 7.26 2.508 1.335 5.184 2.502 5.937 3.003.752.5 2.09-.834 0-2.252-2.09-1.42-4.934-3.839-2.76-5.007 2.175-1.168 3.93-1.835 4.683-2.754.753-.917 0-1-1.756-.917-1.757.083-3.609.083-2.056-2.17 1.554-2.253 1.89-3.67 1.89-5.006 0-1.335-.838-.834-2.343.917-1.505 1.753-2.006 2.588-1.839.167.167-2.419.516-8.637-.753-6.758",
    fill: "#F3F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.196 84.117c0 3.18-2.583 5.757-5.77 5.757-3.186 0-5.77-2.577-5.77-5.757 0-3.18 2.584-8.03 5.77-8.03 3.187 0 5.77 4.85 5.77 8.03",
    fill: "#1786C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76 83.47a3.33 3.33 0 0 1-3.333 3.328 3.331 3.331 0 0 1-3.335-3.327 3.33 3.33 0 0 1 3.335-3.327 3.33 3.33 0 0 1 3.334 3.327",
    fill: "#050706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52 80.967a2.016 2.016 0 0 1-2.018 2.014 2.016 2.016 0 0 1-2.017-2.014c0-1.111.903-2.013 2.017-2.013 1.115 0 2.018.902 2.018 2.013",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.133 124.083c-11.27 5.068-28.971 5.171-29.414 5.173-.443-.002-18.143-.105-29.415-5.173v5.173s10.063 5.833 29.394 5.966H265.74c19.332-.133 29.393-5.966 29.393-5.966v-5.173z",
    fill: "#1786C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.72 120.454c-13.699-.013-18.632-12.327-18.632-12.327 4.718 24.38 18.19 21.244 18.631 21.135.441.11 13.913 3.245 18.631-21.135 0 0-4.933 12.314-18.63 12.327",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.74 120.458v-.004l-.021.002-.021-.002v.004c-.434.042-6.895.615-10.973-3.018v15.029c0 5.246 3.684 10.49 10.973 10.511v.002H265.74v-.002c7.289-.02 10.973-5.265 10.973-10.511v-15.03c-4.078 3.634-10.54 3.061-10.973 3.02",
    fill: "#FAD7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.582 137.365c.02-.04.043-.075.062-.115-.672.247-6.615 4.952-12.371 2.592-6.104-2.503-4.767-13.955-4.767-13.955 7.652 4.068 14.681.696 18.229-1.806v-6.642c-4.08 3.634-10.54 3.062-10.974 3.019v-.004l-.021.002a.388.388 0 0 1-.021-.002v.004c-.433.043-6.895.615-10.973-3.019v15.03c0 5.247 3.685 10.49 10.973 10.511v.002l.02-.001.022.001v-.002c2.42-.007 4.434-.598 6.057-1.566 0 0 2.276-1.166 3.764-4.049",
    fill: "#EAB8BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.365 118.787s12.58 6.412 23.348-1.347c0 0-10.849 6.542-22.21-.39l-1.138 1.737z",
    fill: "#393A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.443 121.276s4.055 9.196 3.511 13.452c0 0 3.638-9.006 3.01-13.452h-6.521z",
    fill: "#EAB8BB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.549 189.23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.926 10.372c.187-2.79 2.492-5.004 5.337-5.004.011 0 .022.003.032.003C6.46 2.558 8.777.32 11.638.32c2.451 0 4.496 1.649 5.143 3.887a5.33 5.33 0 0 1 2.68-.74c2.362 0 4.345 1.53 5.066 3.641a5.343 5.343 0 0 1 1.773-.322 5.368 5.368 0 0 1 5.374 5.362c0 .174-.035.337-.05.508l.05.003v1.19c0 2.363-1.969 4.28-4.399 4.28H5.285c-2.427 0-4.396-1.916-4.396-4.277V10.37l.037.002z",
    fill: "#FEFEFE",
    mask: "url(#j)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)",
    transform: "rotate(25 6.529 656.356)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.853 39.388c-1.344-1.891-1.723-3.085-1.137-3.58.88-.745 4.257.839 5.407-.354 1.15-1.192-1.939-4.322-.775-5.835 1.163-1.514 3.898 1.063 5.247-.548 1.35-1.612-1.27-3.876 0-5.656 1.27-1.78 4.718 2.336 5.782 1.448 1.064-.888-4.05-3.7-1.754-7.872 2.295-4.172 76.009 26.61 80.15 37.723 2.76 7.41-13.872 21.898-49.898 43.466L21.853 39.388z",
    fill: "#838C91",
    mask: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.372 17.082c2.49-1.14 5.154-.802 7.994 1.012M16.827 1.85c1.84 1.84 3.094 3.481 3.763 4.924M6.08 5.907c3.004 1.294 5.56 2.729 7.668 4.304",
    stroke: "#8C9DA5",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    mask: "url(#m)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)",
    transform: "scale(-1 1) rotate(31 -227.988 -422.545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.853 39.388c-1.344-1.891-1.723-3.085-1.137-3.58.88-.745 4.257.839 5.407-.354 1.15-1.192-1.939-4.322-.775-5.835 1.163-1.514 3.898 1.063 5.247-.548 1.35-1.612-1.27-3.876 0-5.656 1.27-1.78 4.718 2.336 5.782 1.448 1.064-.888-4.05-3.7-1.754-7.872 2.295-4.172 76.009 26.61 80.15 37.723 2.76 7.41-13.872 21.898-49.898 43.466L21.853 39.388z",
    fill: "#838C91",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.372 17.082c2.49-1.14 5.154-.802 7.994 1.012M16.827 1.85c1.84 1.84 3.094 3.481 3.763 4.924M6.08 5.907c3.004 1.294 5.56 2.729 7.668 4.304",
    stroke: "#8C9DA5",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    mask: "url(#p)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(122 66)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0079BF",
    x: 0.725,
    width: 30,
    height: 29,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.568 10.995h-.607c-.691 0-1.282.244-1.771.734-.49.489-.734 1.08-.734 1.771v6.264c0 .691.244 1.282.734 1.771.49.49 1.08.734 1.771.734H21.49c.691 0 1.282-.244 1.771-.734.49-.49.734-1.08.734-1.771V13.5c0-.692-.244-1.282-.734-1.771a2.414 2.414 0 0 0-1.771-.734h-.685c-.04-.392-.098-.777-.177-1.155a8.334 8.334 0 0 0-.313-1.116 7.056 7.056 0 0 0-.655-1.478 5.414 5.414 0 0 0-.97-1.204 4.736 4.736 0 0 0-1.546-.969 5.248 5.248 0 0 0-1.918-.342c-.692 0-1.331.11-1.918.333a4.663 4.663 0 0 0-1.566.978c-.366.353-.685.75-.96 1.194a7.226 7.226 0 0 0-.684 1.468 9.28 9.28 0 0 0-.323 1.126c-.085.385-.154.773-.206 1.165zm2.525 0a9.98 9.98 0 0 1 .147-.744 8.44 8.44 0 0 1 .205-.725 5.72 5.72 0 0 1 .44-.94c.164-.273.35-.508.559-.704.235-.209.496-.368.783-.48.287-.11.62-.166.998-.166s.711.056.998.167c.287.11.542.27.764.48.195.182.375.414.538.694.163.28.303.59.42.93.08.235.144.476.197.724.052.248.097.503.137.764h-6.186zM8.961 13.5H21.49v6.264H8.96V13.5z",
    fill: "#055A8C"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(377 66)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#5AAC44",
    x: 0.725,
    width: 30,
    height: 29,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3F6F21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.567 15.535v-1.313c-1.5-.12-2.952-.568-4.323-1.245-.964-.475-1.685-.955-2.105-1.293l1.374-1.708c.066.053.211.16.429.305.373.248.8.497 1.272.73 1.081.534 2.213.893 3.353 1.01V6.47h2.193v5.47c1.012-.17 2.064-.512 3.113-.985.547-.246 1.053-.51 1.505-.774a9.79 9.79 0 0 0 .539-.334l1.238 1.81c-.13.089-.359.234-.672.417-.515.3-1.089.6-1.71.88-1.332.6-2.681 1.025-4.013 1.204v1.44c1.332.179 2.681.603 4.013 1.203.621.28 1.195.58 1.71.88.313.183.542.329.672.418l-1.238 1.809a9.79 9.79 0 0 0-.54-.334 16.212 16.212 0 0 0-1.504-.774c-1.05-.473-2.1-.815-3.113-.985v5.668h-2.193v-5.747c-1.14.117-2.272.476-3.353 1.01-.472.232-.9.481-1.272.73a6.551 6.551 0 0 0-.429.304l-1.374-1.708c.42-.337 1.141-.817 2.105-1.293 1.371-.676 2.824-1.125 4.323-1.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.555 14.83a8.83 8.83 0 1 1-17.66 0 8.83 8.83 0 0 1 17.66 0zm-2.193 0a6.637 6.637 0 0 0-6.638-6.637 6.638 6.638 0 1 0 6.638 6.637z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 23)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FF80CE",
    x: 0.725,
    width: 30,
    height: 29,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CD5A91",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.567 15.535v-1.313c-1.5-.12-2.952-.568-4.323-1.245-.964-.475-1.685-.955-2.105-1.293l1.374-1.708c.066.053.211.16.429.305.373.248.8.497 1.272.73 1.081.534 2.213.893 3.353 1.01V6.47h2.193v5.47c1.012-.17 2.064-.512 3.113-.985.547-.246 1.053-.51 1.505-.774a9.79 9.79 0 0 0 .539-.334l1.238 1.81c-.13.089-.359.234-.672.417-.515.3-1.089.6-1.71.88-1.332.6-2.681 1.025-4.013 1.204v1.44c1.332.179 2.681.603 4.013 1.203.621.28 1.195.58 1.71.88.313.183.542.329.672.418l-1.238 1.809a9.79 9.79 0 0 0-.54-.334 16.212 16.212 0 0 0-1.504-.774c-1.05-.473-2.1-.815-3.113-.985v5.668h-2.193v-5.747c-1.14.117-2.272.476-3.353 1.01-.472.232-.9.481-1.272.73a6.551 6.551 0 0 0-.429.304l-1.374-1.708c.42-.337 1.141-.817 2.105-1.293 1.371-.676 2.824-1.125 4.323-1.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.555 14.83a8.83 8.83 0 1 1-17.66 0 8.83 8.83 0 0 1 17.66 0zm-2.193 0a6.637 6.637 0 0 0-6.638-6.637 6.638 6.638 0 1 0 6.638 6.637z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(332 23)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#C377E0",
    x: 0.725,
    width: 30,
    height: 29,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.568 11.995h-.607c-.691 0-1.282.244-1.771.734-.49.489-.734 1.08-.734 1.771v6.264c0 .691.244 1.282.734 1.771.49.49 1.08.734 1.771.734H22.49c.691 0 1.282-.244 1.771-.734.49-.49.734-1.08.734-1.771V14.5c0-.692-.244-1.282-.734-1.771a2.414 2.414 0 0 0-1.771-.734h-.685c-.04-.392-.098-.777-.177-1.155a8.334 8.334 0 0 0-.313-1.116 7.056 7.056 0 0 0-.655-1.478 5.414 5.414 0 0 0-.97-1.204 4.736 4.736 0 0 0-1.546-.969 5.248 5.248 0 0 0-1.918-.342c-.692 0-1.331.11-1.918.333a4.663 4.663 0 0 0-1.566.978c-.366.353-.685.75-.96 1.194a7.226 7.226 0 0 0-.684 1.468 9.28 9.28 0 0 0-.323 1.126c-.085.385-.154.773-.206 1.165zm2.525 0a9.98 9.98 0 0 1 .147-.744 8.44 8.44 0 0 1 .205-.725 5.72 5.72 0 0 1 .44-.94c.164-.273.35-.508.559-.704.235-.209.496-.368.783-.48.287-.11.62-.166.998-.166s.711.056.998.167c.287.11.542.27.764.48.195.182.375.414.538.694.163.28.303.59.42.93.08.235.144.476.197.724.052.248.097.503.137.764h-6.186zM9.961 14.5H22.49v6.264H9.96V14.5z",
    fill: "#89609E"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.1c165fd76226791fc137c6d31deb9545.svg";
export { ForwardRef as ReactComponent };